<template>
    <Dialog :visible="visible" @update:visible="updateVisible" header="Selecionar Provedor" @show="onShow"
        @hide="onHide" class="w-11 lg:w-8" modal>
        <div>
            <div>
                <div>
                    <Toolbar class="mb-2 bg-gray-100">
                        <template #end>
                            <form class="flex w-full gap-1" @submit.prevent="onSubmitBusca">
                                <div>
                                    <InputGroup>
                                        <InputGroupAddon>Nome</InputGroupAddon>
                                        <InputText class="w-full" v-model="params.filter.nome" autofocus />
                                    </InputGroup>
                                </div>

                                <div>
                                    <InputGroup>
                                        <InputGroupAddon style="width: 130px;">CPF/CNPJ</InputGroupAddon>
                                        <InputText class="w-full" v-model="params.filter.documento" />
                                    </InputGroup>
                                </div>

                                <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                                    class="p-button-sm" />
                                <Button icon="pi pi-eraser" label="Limpar" severity="danger" size="small"
                                    class="p-button-sm" @click="onClearBusca" />
                                <Button v-if="permissoes.PROVEDOR_INCLUIR" icon="pi pi-plus" label="Incluir"
                                    severity="info" size="small" class="p-button-sm" @click="openForm" />
                                <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                    class="p-button-sm" @click="loadData" />
                            </form>
                        </template>
                    </Toolbar>

                    <DataTable :value="lista" :loading="isLoading" v-model:selection="selected" selectionMode="single"
                        size="small" stripedRows showGridlines @row-dblclick="onDbClick" scrollable
                        scrollHeight="calc(100vh - 400px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                        @sort="onTableSort">

                        <Column style="width: 100px" field="id" header="#" sortable></Column>
                        <Column field="nome" header="Nome" sortable></Column>
                        <Column field="documento" header="CPF/CNPJ" sortable>
                            <template #body="{ data }">
                                {{ formatDocument(data.documento) }}
                            </template>
                        </Column>

                        <template #empty>
                            <div class="text-center text-gray-600">
                                Nenhum registro encontrado
                            </div>
                        </template>
                    </DataTable>
                    <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                        @page="onPage">
                    </Paginator>
                </div>

            </div>

            <div class="flex justify-content-end gap-1">
                <Button label="Selecionar" severity="success" icon="pi pi-check-circle" size="small" @click="selecionar"
                    :disabled="!selected" class="flex align-items-center justify-content-center" />
                <Button label="Fechar" severity="warn" icon="pi pi-times" size="small" @click="updateVisible(false)"
                    class="flex align-items-center justify-content-center" />
            </div>
        </div>

        <ProvedorForm :visible="visibleForm" :data="item" @close="closeForm" @save="loadData" />
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import Card from 'primevue/card';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import ScrollPanel from 'primevue/scrollpanel';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import ProvedorForm from '@/page/provedor/Form.vue';

import Provedor from '@/service/provedor.js';

import Filter from '@/utils/Filter.js';
import Mask from '@/utils/Mask.js';

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        permissoes: {},
    },
    emits: ['select', 'close'],
    components: {
        Dialog,
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        ScrollPanel,
        InputGroup,
        InputGroupAddon,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,

        /* Form */
        ProvedorForm,
    },
    data() {
        return {
            lista: [],
            isLoading: false,

            selected: null,

            item: {},
            visibleForm: false,

            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    methods: {
        formatDocument(documento) {
            if (documento) {
                if (documento.length <= 11) {
                    return Mask.cpf(documento);
                }
                return Mask.cnpj(documento);
            }
            return documento;
        },
        openForm() {
            this.item = {};
            this.visibleForm = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;
        },
        onDbClick(event) {
            this.selected = event.data;
            this.$emit('select', event.data);
            this.$emit('close');
        },
        onShow() {
            this.loadData();
        },
        onHide() {
            this.selected = null;
        },
        updateVisible(visible) {
            this.$emit('close', visible);
        },
        selecionar() {
            if (this.selected) {
                this.$emit('select', this.selected);
                this.$emit('close');
            }
        },
        limpar() {
            this.$emit('select', null);
            this.$emit('close');
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Provedor.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        onClearBusca(event) {
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
